import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import "../App.css";

const OIDCLogin = () => {
  const { login, isLoading } = useAuth();
  const [isInitiating, setIsInitiating] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    const originalErrorHandler = window.onerror;
    const originalUnhandledRejection = window.onunhandledrejection;
    const originalConsoleError = console.error;
    const originalConsoleWarn = console.warn;

    window.isLoggingIn = true;

    const suppressErrors = () => {
      window.onerror = () => true;
      window.onunhandledrejection = (event) => { event.preventDefault(); return true; };
      console.error = () => {};
      console.warn = () => {};
    };

    const restoreErrors = () => {
      window.onerror = originalErrorHandler;
      window.onunhandledrejection = originalUnhandledRejection;
      console.error = originalConsoleError;
      console.warn = originalConsoleWarn;
      window.isLoggingIn = false;
    };

    try {
      setIsInitiating(true);
      setError(null);
      suppressErrors();
      if (window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__) {
        window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__.iframeHandler = () => {};
      }
      await login();
    } catch (err) {
      restoreErrors();
      setError(err.message || "Failed to initiate login");
      setIsInitiating(false);
    }
  };

  if (isLoading) {
    return (
      <div className="login-container">
        <div className="login-loading">
          <div className="loading-spinner"></div>
          <p>A carregar...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">

      {/* ── Left: Dark energy panel ── */}
      <div className="login-left">
        <span className="login-left-wordmark"></span>

        <div className="login-energy-center">
          <div className="energy-rings">
            <div className="energy-ring ring-1"></div>
            <div className="energy-ring ring-2"></div>
            <div className="energy-ring ring-3"></div>
            <div className="energy-core">
              <svg width="39" height="39" viewBox="0 0 24 24" fill="none">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="#102F3F" />
              </svg>
            </div>
          </div>
          <h2 className="energy-name">Joninhas AI</h2>
          <p className="energy-desc">Assistente de vendas inteligente</p>
        </div>

        <span className="login-left-footer">© 2026 Lugotech</span>
      </div>

      {/* ── Right: Login form ── */}
      <div className="login-right">
        <div className="login-right-inner">

          {/* Logo mark */}
          <div className="login-right-logo">
            <img src="/lugotech-logo.png" alt="Lugotech" className="w-30 h-30 login-logomark-img" />
          </div>

          {/* Joninhas illustration */}
          <div className="joninhas-illustration">
            <div className="joninhas-blob"></div>
            <img
              src="/joninhas_ai.png"
              alt="Joninhas AI"
              className="joninhas-img"
            />
            <div className="joninhas-badge">
              <span className="joninhas-badge-dot"></span>
              Online
            </div>
          </div>

          {/* Heading */}
          <div className="login-form-card">
            <div className="login-right-heading">
              <span className="login-eyebrow">Bem-vindo</span>
              <h1 className="login-title">Falar com o Joninhas</h1>
            </div>

            {/* SSO Button */}
            <button
              onClick={handleLogin}
              disabled={isInitiating}
              className="sso-button"
            >
              <span className="sso-button-inner">
                {isInitiating ? (
                  <>
                    <span className="sso-spinner"></span>
                    A redirecionar...
                  </>
                ) : (
                  <>Login com SSO</>
                )}
              </span>
            </button>

            {error && (
              <div className="login-error">
                <strong>Erro:</strong> {error}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OIDCLogin;
